import React from "react";
import { resellerSteps } from "../../data/reseller";

export const ResellerSteps = () => (
  <section className="max-w-[1300px] mx-auto px-5 md:px-6 py-16" data-testid="reseller-steps">
    <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight">Como funciona</h2>
    <ol className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {resellerSteps.map((s, i) => (
        <li key={s.title} data-testid={`reseller-step-${i + 1}`} className="relative rounded-2xl border border-white/10 bg-ink-2/80 p-6">
          <span className="text-6xl font-extrabold brand-gradient-text leading-none">{i + 1}</span>
          <h3 className="mt-4 text-lg font-bold">{s.title}</h3>
          <p className="mt-2 text-sm text-silver/70 leading-relaxed">{s.desc}</p>
        </li>
      ))}
    </ol>
  </section>
);
